import { MIN_THUMB_WIDTH } from "./constants";
import { getValueWithinMaxMin } from "./get_max_min_values";
import { Direction } from "./types";

export const calculateThumbWidth = (
  direction: Direction,
  deltaX: number,
  prevThumbWidth: number,
  prevThumbLeft: number,
  currentThumbLeft: number,
  clientWidth: number
): number => {
  const newWidth = direction === Direction.Right ? prevThumbWidth + deltaX : prevThumbWidth - deltaX;
  const MAX_THUMB_WIDTH =
    direction === Direction.Right ? clientWidth - currentThumbLeft : prevThumbLeft + prevThumbWidth;
  return getValueWithinMaxMin(newWidth, MAX_THUMB_WIDTH, MIN_THUMB_WIDTH);
};
